<script>
    import TargetInfo from "../components/TargetInfo.svelte";
    import AnalyzeControl from "../components/AnalyzeControl.svelte";
    import AnalyzeResultsNavigation from "../components/AnalyzeResultsNavigation.svelte";
    import AnalyzeResultsCategoryWrapper from "../components/AnalyzeResultsCategoryWrapper.svelte";
    import {afterUpdate, onDestroy, onMount} from "svelte";
    import {getAnalyzeProgress, getUserInfo} from "../lib/ApiRequests.svelte";
    import BindCard from "../components/BindCard.svelte";
    import ChangeTempPasswordAlert from "../components/ChangeTempPasswordAlert.svelte";
    import AnalyzesLimitAlert from "../components/AnalyzesLimitAlert.svelte";
    import SubscriptionExpired from "../components/SubscriptionExpired.svelte";
    import {Constans} from "../lib/Constants";
    import RecoverSubscription from "../components/RecoverSubscription.svelte";
    import FreeAccessAlert from "../components/FreeAccessAlert.svelte";
    import FreeAccessUnlockDataAlert from "../components/FreeAccessUnlockDataAlert.svelte";
    import {_} from '../lib/i18n';


    export let currentView = 'likes';

    onMount(() => {
        //window.scrollTo(0, 0);

        setTitle($_('analyze.panelTitle'));

        onAnalyzeChange();

        document.addEventListener('refreshAnalyze', refreshAnalyze, {
            capture: true
        });

        if (params.lastRoute) {
            currentView = params.lastRoute;
        }

    });

    onDestroy(() => {
        document.removeEventListener('refreshAnalyze', refreshAnalyze, {
            capture: true
        });

        try {
            params.setState({
                lastAccount: analyze.id,
                lastRoute: currentView,
            })
        } catch (err) {
            console.error(err);
        }
    });

    function setTitle(title) {
        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: title,
                });
            }
        } catch (err) {
            console.error(err);
        }
    }

    export let analyze;
    export let date;
    //$: analyze && setTitle('Дашборд');
    export let currentAnalyze;
    export let language;

    export let availableTariffs = [];
    export let bindCardTariff = {};
    $: bindCardTariff = (availableTariffs ? availableTariffs.week : {});

    let id;
    $: id = analyze ? analyze.id : null;
    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);
    export let params;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    function isAllDataLoaded() {
        if (!analyze || !analyze.account || analyze.account.name === null) return false;

        return true;
    }

    async function loadAccountInfo() {
        const infoResponse = await getUserInfo(analyze.account.username);
        if (infoResponse.status === 'ok') {
            analyze.account.name = infoResponse.data.name;
            analyze.account.followers_count = infoResponse.data.followers_count;
            analyze.account.follows_count = infoResponse.data.follows_count;
            analyze.account.media_count = infoResponse.data.media_count;
            analyze = analyze;
        }
    }

    $: analyze && !isAllDataLoaded() && loadAccountInfo();


    let identity;
    $: identity = (params ? params.identity : null);
    let showBindCard;
    $: showBindCard = identity ? identity.spy_show_first_pay_modal : false;

    export let totalAnalyzes;
    export let nextId;
    export let prevId;

    function refreshAnalyze(event) {
        const id = event.detail.id;
        const newData = event.detail;

        if (analyze.id === id) {
            analyze = newData;
        }
    }

    function changeView(view) {
        currentView = view;
    }

    let progressInterval;
    let isLoadingProgress = false;
    function onAnalyzeChange() {
        if (progressInterval) {
            clearInterval(progressInterval);
        }
        if (isTemporary) return;

        try {
            progressInterval = setInterval(async () => {
                if (isLoadingProgress) return;

                isLoadingProgress = true;
                try {
                    const progress = await getAnalyzeProgress(id, date);
                    if (params.updateAnalyzeProgress instanceof Function) {
                        //params.updateAnalyzeProgress(id, progress.data);

                        analyze.progress = progress.data;
                        analyze.commentsProgress = progress.data.comments;
                        analyze.likesProgress = progress.data.likes;
                        analyze.storiesProgress = progress.data.stories;
                        analyze.guestsProgress = progress.data.guestsProgress;
                        analyze.unfollowsProgress = progress.data.unfollowsProgress;
                        analyze.deletedProgress = progress.data.deletedProgress;
                        analyze.fansProgress = progress.data.fansProgress;
                        analyze.postsProgress = progress.data.postsProgress;
                        analyze.listProgress = progress.data.list;
                        analyze.status = progress.data.analyze_status;
                        analyze.feedsUpdateIsFinished = progress.data.feedsUpdateIsFinished;
                        analyze.needRestart = progress.data.needRestart;
                        analyze.handler = progress.data.handler;

                        console.log(analyze.available_dates.length < progress.data.available_dates.length, analyze.available_dates.length, progress.data.available_dates.length);

                        if (analyze.available_dates.length < progress.data.available_dates.length) {
                            analyze.available_dates = progress.data.available_dates;
                            setTimeout(() => {
                                date = progress.data.available_dates[progress.data.available_dates.length - 1];
                                window.location.href = '/instashpion/dashboard/analyze/'+id+'?date=' + date + '&clear-cache=y';
                            }, 500);
                        }

                        if (analyze.result.fans.length === 0) {
                            analyze.result.fans = progress.data.fans;
                        }

                        analyze = analyze;
                    }
                } catch (err) {
                    console.error(err);
                }

                isLoadingProgress = false;
            }, 5000);
        } catch (err) {
            console.error(err);
        }
    }

    $: id && onAnalyzeChange();

    let subscriptionStatus = 0;
    $: identity && identity.spy_subscription && (subscriptionStatus = Number(identity.spy_subscription.status));
    let subscriptionIsRecoverable = false;
    $: subscriptionStatus && identity.spy_paid_till && (subscriptionIsRecoverable = (new Date(identity.spy_paid_till * 1000)) > (new Date()));
    let subscriptionIsCancelled = false;
    $: subscriptionStatus && (subscriptionIsCancelled = (subscriptionStatus === Constans.spySubscriptionStatuses.CANCELED && subscriptionIsRecoverable));

    let subscriptionIsExpired = false;
    $: identity && identity.spy_subscription && (subscriptionIsExpired = !identity.isActiveSubscription());
    let freeAccessTrialExpired = false;
    $: identity && (freeAccessTrialExpired = !identity.isActiveFreeAccessTrial());
    let isEnabledFreeTrial = false;
    $: identity && (isEnabledFreeTrial = identity.isEnabledFreeTrial());
    let maxAnalyzes = 0;
    $: identity && (maxAnalyzes = identity.spy_balance + totalAnalyzes);
    let isTemporaryPassword = true;
    $: identity && (isTemporaryPassword = identity.is_temporary_password);
    let isTemporaryEmail = false;
    $: identity && (isTemporaryEmail = identity.is_temporary_email);
    let isKeepTemporaryPassword = false;
    $: identity && (isKeepTemporaryPassword = (identity.keep_temporary_password ?? false));
</script>


<div class="canvas__col canvas__col_left">
    {#if isTemporaryPassword && !isKeepTemporaryPassword && !isTemporaryEmail}
        <ChangeTempPasswordAlert {params} />
    {/if}

    {#if identity.showAnalyzesLimitWarning}
        <AnalyzesLimitAlert bind:identity={identity} {params} {maxAnalyzes} />
    {/if}

    {#if subscriptionIsCancelled}
        <RecoverSubscription {params} {identity} />
    {:else if subscriptionIsExpired}
        <SubscriptionExpired {params} />
    {/if}

    <TargetInfo bind:analyze={analyze} bind:identity={identity} {params} {totalAnalyzes} {nextId} {prevId} {currentView} />

    {#if showBindCard && !isEnabledFreeTrial}
        <BindCard tariff={bindCardTariff} {identity} {language} {path} />
    {/if}
    {#if isEnabledFreeTrial}
        <FreeAccessAlert {params} {analyze} />
    {/if}

</div>
<div class="canvas__col canvas__col_right">
    {#if isEnabledFreeTrial && analyze && analyze.checkIsFinished()}
        <FreeAccessUnlockDataAlert bind:analyze={analyze} {params} />
    {:else}
        <AnalyzeControl bind:analyze={analyze} bind:date {params} {subscriptionIsExpired} {freeAccessTrialExpired} {isEnabledFreeTrial} {language} />
    {/if}

    <AnalyzeResultsNavigation bind:currentView={currentView} {params} bind:analyze={analyze} showNavButtons={!showBindCard} >
        <section class="feed-content__wrapper" slot="inner">
            {#if !showBindCard}
                <AnalyzeResultsCategoryWrapper bind:currentView={currentView} bind:analyze={analyze} {params} bind:date />
            {/if}
        </section>
    </AnalyzeResultsNavigation>


</div>